<template>
<div class="confirm-page">
  <div class="hw-card success-card">
    <div class="success-icon">
      <i class="pi pi-check-circle"></i>
    </div>

    <h1 class="success-title">Merci !</h1>
    <p class="success-subtitle">Votre rendez-vous est confirmé</p>

    <div class="appointment-summary">
      <div class="summary-row">
        <i class="pi pi-calendar"></i>
        <span>{{ store.datestring }}</span>
      </div>
      <div class="summary-row">
        <i class="pi pi-clock"></i>
        <span>{{ store.timestring }}</span>
      </div>
    </div>

    <div class="salon-info">
      <img src="../assets/iroquoise_logo_rvb.png" class="salon-logo" alt="L'Iroquoise" />
      <div class="salon-details">
        <strong>L'Iroquoise</strong>
        <span>Chemin du couchant 16</span>
        <span>1752 Villars-sur-Glâne</span>
      </div>
    </div>
  </div>

  <div class="hw-card info-card">
    <div class="info-row">
      <i class="pi pi-envelope info-icon"></i>
      <p class="info-text">
        Vous allez recevoir une <strong>confirmation par SMS dans les minutes à venir.</strong>
        Si vous ne recevez pas de confirmation, ou que vous souhaitez annuler ou déplacer votre
        rendez-vous, ou pour toute question, contactez-moi au
        <a href="tel:0782381360">078 238 13 60</a>
      </p>
    </div>
  </div>
</div>
</template>

<style scoped>
.confirm-page {
  text-align: center;
}

.success-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ecfdf5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.success-icon .pi {
  font-size: 2rem;
  color: #10b981;
}

.success-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.25rem 0;
}

.success-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0 0 1.25rem 0;
}

.appointment-summary {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
  max-width: 320px;
  margin-bottom: 1.5rem;
}

.summary-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.summary-row .pi {
  color: #3b82f6;
  font-size: 1.1rem;
}

.salon-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.salon-logo {
  width: 60px;
  height: auto;
  border-radius: 8px;
}

.salon-details {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.salon-details strong {
  color: #1e293b;
  font-size: 0.95rem;
}

.info-card {
  margin-top: 0.75rem;
  text-align: left;
  padding: 1rem;
}

.info-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.info-icon {
  color: #3b82f6;
  font-size: 1.1rem;
  margin-top: 0.15rem;
  flex-shrink: 0;
}

.info-text {
  margin: 0;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.info-text a {
  color: #3b82f6;
  font-weight: 600;
  text-decoration: none;
}

.info-text a:hover {
  text-decoration: underline;
}
</style>

<script setup>
import { useMainStore } from '../store'
import { defineEmits, onMounted } from "vue";

const emit = defineEmits(['next-page', 'previous-page', 'go-home', 'go-confirm']);

const store = useMainStore();

onMounted(() => {
  if (!store.length) {
    emit('go-home');
  }
});
</script>
